import { useState, useRef } from "react";
import PenHolder from "../images/PenHolder.jpg"; // Adjust the path as necessary
// import BlenderAnim from "../images/BlenderAnim.jpg"; // Add a thumbnail for your animation

function ThreeDModel() {
    const [isImageEnlarged, setImageEnlarged] = useState(false);
    const [enlargedImage, setEnlargedImage] = useState(null);
    const blenderVideoRef = useRef(null);

    const toggleImageSize = (img = null) => {
        setImageEnlarged(!isImageEnlarged);
        setEnlargedImage(img);
    };

    // Play from 3 seconds
    const handlePlayFrom3Sec = () => {
        if (blenderVideoRef.current) {
            blenderVideoRef.current.currentTime = 3;
            blenderVideoRef.current.play();
        }
    };

    // Play from 4 seconds
    const handlePlayFrom4Sec = () => {
        if (blenderVideoRef.current) {
            blenderVideoRef.current.currentTime = 4;
            blenderVideoRef.current.play();
        }
    };

    return (
      <div className="model-section">
        <h2 className="mb-3">Discover Our Expertly Crafted 3D Models & Animations</h2>
        
        {/* Pen Holder Model */}
        <div className="model-item card mb-3 p-2 shadow-mb-3 bg-light">
          <div className="row align-items-center">
            <div className="col-auto mb-3 mb-md-0">
              <img 
                src={PenHolder} 
                alt="3D Model - Pen Holder" 
                className="img-fluid rounded"
                style={{ maxWidth: "150px", cursor: "pointer" }}
                onClick={() => toggleImageSize(PenHolder)}
              />
            </div>
            <div className="col text-center text-md-start">
              <h5 className="mb-1">Pen Holder</h5>
              <p className="mb-1">
                A sleek and modern design for organizing your pens. 
                The image shows the model printed in multicolor using PLA filament.
              </p>
              <a 
                href="https://3dmodelsse.s3.us-east-1.amazonaws.com/Pen-holder-Redo.3mf" 
                download 
                className="btn btn-primary btn-sm"
              >
                Download 3D Model
              </a>
            </div>
          </div>
        </div>

        {/* Blender Animation Slot */}
        <div className="model-item card mb-3 p-2 shadow-mb-3 bg-light">
          <div className="row align-items-center">
            <div className="col text-center text-md-start">
              <h5 className="mb-1">Blender 10s Animation</h5>
              <p className="mb-1">
                Dive into the world of 3D animation! This 10-second Blender animation showcases smooth motion perfect for portfolios or inspiration.
              </p>
              <video
                ref={blenderVideoRef}
                controls
                style={{ width: "100%", maxWidth: "350px", borderRadius: "0.5rem", marginBottom: "0.5rem" }}
                onLoadedMetadata={() => {
                  if (blenderVideoRef.current) {
                    blenderVideoRef.current.currentTime = 3;
                  }
                }}
              >
                <source src="https://3dmodelsse.s3.us-east-1.amazonaws.com/SE_Blender.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <br />
              <a 
                href="https://3dmodelsse.s3.us-east-1.amazonaws.com/SE_Blender.mp4" 
                download 
                className="btn btn-success btn-sm"
              >
                Download Animation
              </a>
            </div>
          </div>
        </div>

        {/* Modal-like enlarged image */}
        {isImageEnlarged && (
          <div 
            className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
            style={{ zIndex: 1050 }}
            onClick={() => toggleImageSize(null)}
          >
            <img 
              src={enlargedImage} 
              alt="Enlarged Preview" 
              className="img-fluid rounded" 
              style={{ maxWidth: "90%", maxHeight: "90%" }} 
            />
          </div>
        )}
      </div>
    );
  }
  
  export default ThreeDModel;